import { notificationTypes } from "./notificationTypes";

export const notification = (notification) => ({
  type: notificationTypes.NOTIFICATION,
  payload: notification,
});

export const clearNotification = () => ({
  type: notificationTypes.CLEAR_NOTIFICATION,
  payload: {
    message: "",
    variant: ""
  },
});
